import { useRecoilValue } from 'recoil';
import { isMobileState } from '@/store/atom';
import type { EcommerceNewsItem } from '../mock/getMockNews';
import { logEvent } from '@/etc/firebase';
import { useParams } from 'react-router-dom';

interface Source {
  url: string;
  press: string;
}

interface LogEventParams {
  url: string;
  press: string;
  targetPage?: string;
}

interface NewsSourcesProps extends Pick<EcommerceNewsItem, 'sources'> {
  isDashboard?: boolean;
}

export const NewsSources = ({ sources, isDashboard }: NewsSourcesProps) => {
  const isMobile = useRecoilValue(isMobileState);
  const { group } = useParams();

  const handleClick = (source: Source) => {
    logEvent('click_news_source', {
      url: source.url,
      press: source.press,
      targetPage: isDashboard ? 'pc_page' : group,
    } as LogEventParams);

    if (typeof window !== 'undefined' && (window as any).ReactNativeWebView) {
      const payload = JSON.stringify({ openExternal: source.url });
      (window as any).ReactNativeWebView.postMessage(payload);
    }
  };

  return (
    <article className="flex flex-col gap-[4px]">
      <h3 className="text-gr-500 Caption1M12">출처</h3>
      <div className="flex flex-wrap gap-[6px]">
        {sources.map((source) =>
          isMobile ? (
            <button
              key={source.url}
              onClick={() => handleClick(source)}
              className="rounded-[4px] bg-gr-100 px-[6px] py-[4px] text-gr-600  transition-colors  duration-500 Caption1M12 "
            >
              {source.press}
            </button>
          ) : (
            <a
              key={source.url}
              href={source.url}
              target="_blank"
              rel="noreferrer"
              className="rounded-[4px] bg-gr-100 px-[6px] py-[4px]  text-gr-600  transition-colors duration-500 Caption1M12"
            >
              {source.press}
            </a>
          ),
        )}
      </div>
    </article>
  );
};
